import { MenuItemSortable } from 'apis/merchant-gateway/insights';

export enum MenuTableColumnIDs {
  NAME = 'NAME',
  SALES = 'SALES_WITH_VAT',
  SALES_PERCENTAGE = 'SALES_WITH_VAT_PERCENTAGE',
  UNITS = 'UNITS',
  UNITS_PERCENTAGE = 'UNITS_PERCENTAGE',
  ORDERS = 'ORDERS',
}

export type MenuTableSortableColumnIDs =
  | MenuTableColumnIDs.SALES_PERCENTAGE
  | MenuTableColumnIDs.UNITS_PERCENTAGE
  | MenuTableColumnIDs.NAME
  | MenuItemSortable;
